export class TableDataColumn {
  public sortOrder = TableDataColumnOrder.None;

  private _defaultSortingColumn = false;
  private _defaultSortingColumnSortOrder?: TableDataColumnOrder;

  constructor(
    public renderColumn: string | undefined,
    public renderColumnDisplay: string,
    public orderable: boolean = false,
    public customColumn: boolean = false,
    sortOrder: TableDataColumnOrder = TableDataColumnOrder.None
  ) {
    this.sortOrder = sortOrder;

    if (this.sortOrder !== TableDataColumnOrder.None) {
      this.orderable = true;
      this._defaultSortingColumn = true;
      this._defaultSortingColumnSortOrder = sortOrder;
    }
  }

  get defaultSortingColumn(): boolean {
    return this._defaultSortingColumn;
  }

  get defaultSortingColumnSortOrder(): TableDataColumnOrder | undefined {
    return this._defaultSortingColumnSortOrder;
  }
}
export enum TableDataColumnOrder {
  Asc,
  Desc,
  None,
}

export class TableData<T> {
  public length = this.data.length;

  constructor(public count: number, public data: T[]) {}
}

export class TableDataResponse<T> {
  count!: number;
  data!: T[];
}

export class TableDataColumnFilter {
  constructor(public columnName: string, public value: string, public filterType: TableDataColumnFilterType) {}
}

export enum TableDataColumnFilterType {
  Equals = '==',
  GreaterThan = '>',
  LessThan = '<',
}
